import React from "react";
import { useLocation } from "react-router-dom";

import routes from "../routes";

import { CBreadcrumb, CBreadcrumbItem } from "@coreui/react";
import { useTranslation } from "react-i18next";

const AppBreadcrumb = () => {
  const { t, i18n } = useTranslation();
  const currentLocation = useLocation().pathname;

  const getRouteName = (pathname, routes) => {
    const currentRoute = routes.find((route) => {
      const routeRegex = new RegExp(`^${route.path.replace(/:\w+/g, "\\w+")}$`);
      return routeRegex.test(pathname);
    });
    return currentRoute ? currentRoute.name : false;
  };

  const getBreadcrumbs = (location) => {
    const breadcrumbs = [];
    location.split("/").reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`;
      const routeName = getRouteName(currentPathname, routes);
      routeName &&
      breadcrumbs.push({
        pathname: currentPathname,
        name: routeName,
        active: index + 1 === array.length,
      });
      return currentPathname;
    });
    // Reverse breadcrumbs if the language is Arabic
    return i18n.language === "ar" ? breadcrumbs.reverse() : breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(currentLocation);

  if ( i18n.language !== "ar" ) {
    return (
      <CBreadcrumb className="my-0" id="breadcrumb-list">
        {/*{breadcrumbs.length ? (*/}
        {/*  <CBreadcrumbItem href="/">{t("Dashboard")}</CBreadcrumbItem>*/}
        {/*) : (*/}
        {/*  <CBreadcrumbItem active>{t("Dashboard")}</CBreadcrumbItem>*/}
        {/*)}*/}

        {breadcrumbs.map((breadcrumb, index) => (
          <CBreadcrumbItem
            {...(breadcrumb.active
              ? { active: true }
              : { href: breadcrumb.pathname })}
            key={index}
          >
            {t(breadcrumb.name)}
          </CBreadcrumbItem>
        ))}
      </CBreadcrumb>
    );
  }
  return (
    <CBreadcrumb className="my-0" id="breadcrumb-list">
      {breadcrumbs.map((breadcrumb, index) => (
        <CBreadcrumbItem
          {...(breadcrumb.active
            ? { active: true }
            : { href: breadcrumb.pathname })}
          key={index}
        >
          {t(breadcrumb.name)}
        </CBreadcrumbItem>
      ))}
      {/*{breadcrumbs.length ? (*/}
      {/*  <CBreadcrumbItem href="/">{t("Forms")}</CBreadcrumbItem>*/}
      {/*) : (*/}
      {/*  <CBreadcrumbItem active>{t("Forms")}</CBreadcrumbItem>*/}
      {/*)}*/}
    </CBreadcrumb>
  );
};

export default React.memo(AppBreadcrumb);